import { Method, Props } from '@owc-types/ComponentInitializeDispatcher';
import { TRACKING_DATA_ATTRIBUTES } from '@owc-packages/Tracking/src/Tracking.config';
import initializeTracking, { formatTrackingString } from '@owc-packages/Tracking/src/TrackingUtils';
import { EventDetailPayload, TrackingInstance } from '@owc-packages/Tracking/src/Tracking';
import { ComponentOptionsWithProps } from 'vue/types/v3-component-options';
import { extractWordFromUrl } from '../../Footer/src/FooterUtils';

export type Category = 'feature' | 'link' | 'video' | 'impression';
export type EventType = 'click';

export type TrackingMixinMethods = {
  addTrackingAction: Method<void>;
  handleCustomTracking: (
    element: Element,
    label: string | null,
    category: Category,
    eventType: EventType,
    name?: string,
    url?: string,
  ) => void;
  handleCustomTrackingDetailed: (
    element: Element,
    eventDetail: EventDetailPayload,
    eventType: EventType,
    url?: string,
  ) => void;
  getEventLabel: (url: string, sectionName: string, label: string) => string;
};

let trackingInstance: TrackingInstance | null = null;

const mixin: ComponentOptionsWithProps<Props, {}, {}, {}, TrackingMixinMethods, {}, {}, {}, ''> = {
  mounted: async function() {
    trackingInstance = await initializeTracking();
    // Adding tracking variables to the action attribute
    if (this.dataAemModuletrackingname) {
      this.addTrackingAction();
    }
  },
  methods: {
    addTrackingAction: function(): void {
      const action = formatTrackingString(
        `${this.dataAemModuletrackingname}${this.dataAemModulename ? `|${this.dataAemModulename}` : ''}`,
      );
      if (action !== undefined) {
        this.$nextTick(() => this.$el.setAttribute(TRACKING_DATA_ATTRIBUTES.componentAction, action));
      }
    },
    handleCustomTracking: function(element, label, category, eventType, name?, URL?): void {
      const trackingDetails = {
        label: label || '',
        category,
        ...(name != undefined && { name }),
        ...(URL != undefined && { URL }),
      };
      this.handleCustomTrackingDetailed(element, trackingDetails, eventType);
    },
    handleCustomTrackingDetailed: function(element, eventDetail: EventDetailPayload, eventType): void {
      if (trackingInstance && eventDetail.label && eventDetail.category) {
        trackingInstance.customTrackingObjectUpdate(
          {
            ...eventDetail,
            label: formatTrackingString(eventDetail.label || ''),
          },
          eventType,
          element,
        );
      }
    },
    getEventLabel: function(url: string, sectionName: string, label: string): string {
      let eventLabel = '';
      const pageName = extractWordFromUrl(url);
      eventLabel = pageName ? `${sectionName}.${pageName}` : `${sectionName}.local.${label}`;
      return eventLabel;
    },
  },
};

export default mixin;
